export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5908.ea275d99.jpg";